import { render } from "./NumberButtonsComponent.vue?vue&type=template&id=7f9919b5"
import script from "./NumberButtonsComponent.vue?vue&type=script&lang=js"
export * from "./NumberButtonsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Documents/DevProjects/AF3/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__